// @flow

import {submitV2AnalyticsEvent} from "../utils/analyticsUtils";

const ORIGIN = "PLP";

const PREVIOUS_PAGE_SELECTOR = ".product-listing__pagination-control--prev";
const NEXT_PAGE_SELECTOR = ".product-listing__pagination-control--next";
const PAGE_SELECT_SELECTOR = ".product-listing__pagination-control--page";

const getSourcePageNumber = (win: WindowProxy): ?string => {
    const wrapper = win.document.querySelector(".product-search-page-body-wrapper");
    return wrapper ? wrapper.getAttribute("data-page-number") : null;
};

const dispatchSelectPaginationAnalytics = (action: string, sourcePageNumber: ?string, destinationPageNumber: ?string) => {
    submitV2AnalyticsEvent("selectPagination", {
        origin: ORIGIN,
        action,
        sourcePageNumber,
        destinationPageNumber
    });
};

const bindPreviousPageControl = (win: WindowProxy, sourcePageNumber: ?string) => {
    const previousPageLink = win.document.querySelector(PREVIOUS_PAGE_SELECTOR);
    if (previousPageLink) {
        previousPageLink.addEventListener("click", function () {
            dispatchSelectPaginationAnalytics(
                "Previous Page",
                sourcePageNumber,
                previousPageLink.getAttribute("data-page-number")
            );
        });
    }
};

const bindNextPageControl = (win: WindowProxy, sourcePageNumber: ?string) => {
    const nextPageLink = win.document.querySelector(NEXT_PAGE_SELECTOR);
    if (nextPageLink) {
        nextPageLink.addEventListener("click", function () {
            dispatchSelectPaginationAnalytics(
                "Next Page",
                sourcePageNumber,
                nextPageLink.getAttribute("data-page-number")
            );
        });
    }
};

const bindPageSelectControl = (win: WindowProxy, sourcePageNumber: ?string) => {
    const pageSelect = win.document.querySelector(PAGE_SELECT_SELECTOR);
    if (pageSelect) {
        pageSelect.addEventListener("change", function () {
            const selectedOption = pageSelect.options[pageSelect.selectedIndex];
            const destinationPageNumber = selectedOption ? selectedOption.getAttribute("data-page-number") : null;
            dispatchSelectPaginationAnalytics("Select Page Number", sourcePageNumber, destinationPageNumber);
        });
    }
};

export const initPaginationAnalytics = (win: WindowProxy) => {
    try {
        const sourcePageNumber = getSourcePageNumber(win);
        bindPreviousPageControl(win, sourcePageNumber);
        bindNextPageControl(win, sourcePageNumber);
        bindPageSelectControl(win, sourcePageNumber);
    } catch (e) {
        console.error(e);
    }
};
